export default "__VITE_ASSET__BlrDXzFi__"